module.exports = __webpack_public_path__ + "./img-phin_103335e62b04daee947115c7e1ece88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/img-phin.png
// module id = 449
// module chunks = 0